<template>
  <router-link class="bottom-nav-item w-[20vw] flex justify-center" :to="to" v-if="!cart">
    <slot></slot>
    <span class="text-sm absolute opacity-0 translate-y-10 transition-all duration-500">{{ title }}</span>
  </router-link>

  <a class="relative bottom-nav-item w-[20vw] flex justify-center" v-else>
    <slot></slot>
    <span class="text-sm absolute opacity-0 translate-y-10 transition-all duration-500">{{ title }}</span>
  </a>
</template>

<script>
export default {
  name: "BottomNavigationItem",
  props: ['title', 'to', 'cart']
}
</script>

<style>
.bottom-nav-item svg {
  @apply z-10 h-6 w-6 transition-all duration-500
}

.bottom-nav-item.active svg {
  @apply -translate-y-10
}

.bottom-nav-item.active span {
  @apply opacity-100 translate-y-5
}

.bottom-nav-item:nth-child(1).active ~ .indicator{
  transform: translateX(calc(20vw * 2));
}

.bottom-nav-item:nth-child(2).active ~ .indicator{
  transform: translateX(calc(20vw * 1));
}

.bottom-nav-item:nth-child(3).active ~ .indicator{
  transform: translateX(calc(20vw * 0));
}

.bottom-nav-item:nth-child(4).active ~ .indicator{
  transform: translateX(calc(20vw * -1));
}
.bottom-nav-item:nth-child(5).active ~ .indicator{
  transform: translateX(calc(20vw * -2));
}
</style>